import vLangSelector from './LangSelector'
export default {
  install(Vue) {
    Vue.component('vLangSelector', vLangSelector)
  },
}
